import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../i18n';

export const CTASection = ({ data }) => {
  const { t } = useLanguage();
  const cta = data || t.home.cta;
  return (
    <section className="border-t border-graphite-200 bg-graphite-100/40" data-testid="cta-section">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-6 py-24 md:flex-row md:items-end md:justify-between">
        <div>
          <h2 className="max-w-xl text-3xl font-semibold tracking-tight text-steel-bright sm:text-4xl">
            {cta.title}
          </h2>
          <p className="mt-4 max-w-md text-base leading-relaxed text-steel">{cta.body}</p>
        </div>
        <Link
          to="/contato"
          data-testid="cta-section-button"
          className="group flex w-full items-center justify-center gap-3 rounded-sm bg-silver px-6 py-3.5 text-sm font-medium text-graphite transition-colors duration-200 hover:bg-silver-glow sm:w-auto"
        >
          {cta.button}
          <ArrowRight
            size={16}
            className="transition-transform duration-200 group-hover:translate-x-1"
          />
        </Link>
      </div>
    </section>
  );
};
